import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import styles from '@components/ProductCardNew/ProductCardDescription/ProductDescription.styles';
import PriceArea from '@components/ProductCardNew/ProductCardDescription/PriceArea/PriceArea';
import SwatchesArea from '@components/ProductCardNew/ProductCardDescription/SwatchesArea/SwatchesArea';
import ProductCardDesriptionSkeleton from '@components/ProductCardNew/ProductCardDescription/ProductCardDescriptionSkeleton';
import { ISwatch } from '@typescript/index';
import { IGpsrObject } from '@features/categories/typescript';
type PropsType = {
  name: string;
  price: string;
  priceUnit: string | undefined;
  promoPrice: string;
  omnibusPrice: string;
  showFrom: boolean;
  swatches: ISwatch[];
  totalColorsCount?: number;
  isSmall?: boolean;
  isSlider?: boolean;
  isNew?: boolean;
  searchHightlight?: JSX.Element;
  isLoading?: boolean;
  gpsr?: IGpsrObject | undefined;
  productUrl?: string;
  onLinkClick?: () => void;
  onAuxClick?: (e: React.MouseEvent) => void;
};
const ProductCardDescription = ({
  name,
  price,
  priceUnit,
  promoPrice,
  omnibusPrice,
  showFrom,
  swatches,
  totalColorsCount,
  isSmall = false,
  isSlider = false,
  searchHightlight = undefined,
  isLoading = false,
  productUrl,
  onLinkClick,
  onAuxClick,
  gpsr = undefined
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const renderName = () => {
    if (productUrl) {
      return <Link href={productUrl} onClick={onLinkClick} onAuxClick={onAuxClick} sx={styles.nameLink} tabIndex={0}>
          {searchHightlight || name}
        </Link>;
    }
    return <span>{searchHightlight || name}</span>;
  };
  return <div sx={styles.descriptionArea(isSmall, isSlider)}>
      <div>
        {renderName()}
        <PriceArea price={price} promoPrice={promoPrice} omnibusPrice={omnibusPrice} showFrom={showFrom} priceUnit={priceUnit} productUrl={productUrl} onLinkClick={onLinkClick} onAuxClick={onAuxClick} gpsr={gpsr} />
      </div>
      <SwatchesArea swatches={swatches} totalColorsCount={totalColorsCount} />
      {isLoading && <div role="status" aria-live="polite" aria-label={t('loadingProductInformation')}>
          <ProductCardDesriptionSkeleton />
        </div>}
    </div>;
};
export default ProductCardDescription;